import HairPlusPage from 'modules/landings/products/HairPlusPage'
import { GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { gTagManagerTracker } from 'utils/trackers/GoogleTagManagerTracker'

const MaisHair: NextPage = () => {
  const router = useRouter()
  useEffect(() => {
    gTagManagerTracker.trackPageLoad(router.pathname)
  }, [router.pathname])
  return <HairPlusPage />
}

// Static, outside the client-only PersistGate: the page text is in the server HTML (crawlers, AI bots).
export const getStaticProps: GetStaticProps = async () => ({ props: { ssrContent: true } })

export default MaisHair
